import Vue from 'vue'
import VuetifyConfirm from 'vuetify-confirm'
import vuetify from "@/plugins/vuetify"
Vue.use(VuetifyConfirm, {vuetify})
